export default "__VITE_ASSET__Cs0B4lnp__"